namespace TabAurous.OMS {
    export interface ToDoMasterRow {
        ToDoId?: number;
        UserId?: number;
        Username?: string;
        FixedName?: string;
        TaskTypeId?: number;
        Description?: string;
        StartDate?: string;
        EndDate?: string;
        Completed?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ToDoMasterRow {
        export const idProperty = 'ToDoId';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'OMS.ToDoMaster';
        export const deletePermission = 'ToDo:Delete';
        export const insertPermission = 'ToDo:Add';
        export const readPermission = '*';
        export const updatePermission = 'ToDo:Edit';

        export declare const enum Fields {
            ToDoId = "ToDoId",
            UserId = "UserId",
            Username = "Username",
            FixedName = "FixedName",
            TaskTypeId = "TaskTypeId",
            Description = "Description",
            StartDate = "StartDate",
            EndDate = "EndDate",
            Completed = "Completed",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
